module.exports = __webpack_public_path__ + "img/jrcd.a2e1679a.png";